import { Component } from 'opus-angular-seed-core';
import template from './template.html';
@Component({
    bindings: {
        question: '=',
        form: '=',
        sites: '=',
        metaFieldGroups: '=',
        questionPools: '='
    },
    template
})
export default class {}



// WEBPACK FOOTER //
// ./src/app/components/forms/questions/all/question/index.js